/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/PDFImageExtractor.yaml
import { ScanbotPdfImageExtractorImpl } from './impl';
/**
 * Entry point for all PDF image extraction features.
 */
export const ScanbotPdfImageExtractor = {
    /**
     * Extract images from a PDF.
     * @param {string} params.pdfFileUri - The file uri of the PDF to extract images from.
     * @param {PdfExtractorOptions} params.options - The options for PDF image extraction.
     * @returns {Promise<string[]>} - The list of file uris to the extracted images.
     */
    async extractImageFiles(params) {
        return ScanbotPdfImageExtractorImpl.extractImageFiles(params);
    },
};
//# sourceMappingURL=PdfImageExtractor.js.map